export default {
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  alternativeNext: {
    id: 'alternative-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'alternative-previous',
    defaultMessage: 'Previous',
  },
  specialOfferType7: {
    id: 'card_new_battery',
    defaultMessage: 'New Battery',
  },
} as const
